export default "__VITE_ASSET__BpKmLXrR__"